import { render } from "./GroupManagementSection.vue?vue&type=template&id=129c6d54"
import script from "./GroupManagementSection.vue?vue&type=script&lang=js"
export * from "./GroupManagementSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__